import cn from "classnames";

import styles from "./Tabs.module.scss";

interface TabsProps {
  items: {
    key: string;
    title?: string;
    render?: ({
      className,
      key,
      isActive,
    }: {
      className: string;
      key: string;
      isActive: boolean;
    }) => React.ReactNode;
  }[];
  activeKey: string;
  onChange?: (value: string) => void;
}

const Tabs = (props: TabsProps) => {
  const { items, activeKey, onChange } = props;

  return (
    <div className={styles.tabs}>
      {items.map(item => {
        if (item?.render) {
          return item.render({
            key: item.key,
            className: cn(styles.tab, {
              [styles.active]: item.key === activeKey,
            }),
            isActive: item.key === activeKey,
          });
        }

        return (
          <div
            key={item.key}
            className={styles.tab}
            onClick={() => onChange?.(item.key)}
          >
            {item.title || item.key}
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
